import React, {useState} from "react";
import PropTypes from "prop-types";
import {Icon, Menu, MenuItem} from "@material-ui/core";
import SaveTemplateDialog from "./SaveTemplateDialog";
import SelectTemplateDialog from "./SelectTemplateDialog";

const StylesTemplateMenu = (props) => {
    const {anchorEl, onClose} = props;
    const [openSaveTemplate, setOpenSaveTemplate] = useState(false);
    const [openSelectTemplate, setOpenSelectTemplate] = useState(false);
    return (
        <>
            <Menu
                id="styles-template-menu"
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorEl)}
                onClose={onClose}
                PaperProps={{
                    style: {
                        maxHeight: 230,
                        width: '25ch',
                    },
                }}
            >
                <MenuItem style={{padding: 5}} onClick={() => {
                    setOpenSaveTemplate(true)
                    onClose();
                }}>
                    <Icon color={"disabled"} style={{marginRight: 10}}>
                        save
                    </Icon>
                    Save as template
                </MenuItem>
                <MenuItem style={{padding: 5}} onClick={() => {
                    setOpenSelectTemplate(true)
                    onClose();
                }}>
                    <Icon color={"disabled"} style={{marginRight: 10}}>
                        upload
                    </Icon>
                    Load from template
                </MenuItem>
            </Menu>
            <SaveTemplateDialog
                onClose={() => setOpenSaveTemplate(false)}
                open={openSaveTemplate}
            />
            <SelectTemplateDialog
                onClose={() => setOpenSelectTemplate(false)}
                open={openSelectTemplate}
            />
        </>
    )
}

export default StylesTemplateMenu;

StylesTemplateMenu.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func,
}